<template>
  <div
    class="FooterPart w-full h-48 flex justify-center items-center text-base mt-5 flex-col"
    style="background-color: #fafafa"
  >
    <p>
      <!-- This website is website adapted from
      <a href="https://nerfies.github.io/">Nerfies</a> and
      <a href="https://mathvista.github.io/">MathVista</a>, licensed under a
      <a rel="license" href="http://creativecommons.org/licenses/by-sa/4.0/"
        >Creative Commons Attribution-ShareAlike 4.0 International License</a
      >. -->
      License: This website is website adapted from Nerfies and MathVista,
      licensed under a Creative Commons Attribution-ShareAlike 4.0 International
      License.
    </p>
    <br />
  </div>
</template>

<script>
export default {};
</script>

<style></style>
